import React, { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../firebase/AuthContext';
import { useFirebase } from '../firebase/FirebaseContext';

const ServerControl = () => {
  const [podId, setPodId] = useState(null);
  const { user } = useAuth();
  const { db } = useFirebase();
  const [serverStatus, setStatus] = useState(null)

  useEffect(() => {
    if (!user?.orgId) return;
    
    const orgRef = doc(db, 'organisations', user.orgId);

    getDoc(orgRef).then(snap => {
      if (snap.exists()) console.log('orgData', snap.data());
    });

    const unsubOrg = onSnapshot(orgRef, snap => {
      if (snap.exists()) {
        setPodId(snap.data().activeSessionId || null);
      }
    });

    return () => unsubOrg();
  }, [user, db]);

  useEffect(() => {
    // only run once you have a user and an orgId
    if (!user?.uid || !user.orgId) return;
    console.log("listening for org status on", user.orgId);
  
    const statusRef = doc(db, "organisations", user.orgId);
    const unsubscribe = onSnapshot(
      statusRef,
      (snap) => {
        if (!snap.exists()) {
          console.log("org doc not found");
          setStatus(null);
          return;
        }
  
        const s = snap.data().status;
        console.log("org status:", s, (s === "active"));
        // true only if status === "active", else false
        if (s === "active") {
          setStatus("running");
        }
        else if (s === "inactive") {
          setStatus("stopped");
        }
        else if (s === "deploying") {
          setStatus("loading");
        }

      },
      (err) => console.error("status listener error", err)
    );
  
    return () => unsubscribe();
  }, [user, podId]);

  

  const handleServerControl = async () => {
    if (serverStatus === 'loading') {
      console.log("Server is still loading, please wait.");
      fetch(`https://api.canopylabs.ai/deactivate-server?org_id=${encodeURIComponent(user.orgId)}`);
    }
    else if (serverStatus === 'running') { 
      console.log("Server is already running, stopping it...");
      fetch(`https://api.canopylabs.ai/deactivate-server?org_id=${encodeURIComponent(user.orgId)}`);
    }
    else if (serverStatus === 'stopped') {
      fetch(`https://api.canopylabs.ai/activate-server?org_id=${encodeURIComponent(user.orgId)}`);
      console.log("Starting server...");
    }

    console.log("serverStatus", serverStatus);
    return;
  };

  return (
    <button
      onClick={handleServerControl}
      className={`text-sm px-3 mr-2 rounded-lg outline-none hover:scale-105 active:scale-95 transition-all duration-150 h-6 flex items-center justify-center gap-2 ${
        !podId ? 'bg-green-600 text-white hover:bg-green-700' :
        serverStatus === 'loading' ? 'bg-orange-400 text-white hover:bg-orange-500 group' :
        serverStatus === 'running' ? 'bg-red-600 text-white hover:bg-red-700' :
        'bg-green-600 text-white hover:bg-green-700 text-sm'
      }`}
    >
      {serverStatus === 'loading' && (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      )}
      {!podId ? 'Start Server' :
        serverStatus === 'loading' ? (
          <>
            <span className="block group-hover:hidden">Setting up server...</span>
            <span className="hidden group-hover:block">Stop Setup</span>
          </>
        ) :
        serverStatus === 'running' ? 'Stop Server' :
        'Start Server'}
    </button>
  );
};

export default ServerControl;